import { NgFor, NgIf } from '@angular/common';
import {
  Component,
  ViewChild,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { Router, RouterModule } from '@angular/router';
import { BreadcrumbsComponent } from '../components/breadcrumbs/breadcrumb.component';
import { SidenavLinks } from '../navigation.config';
import { CoreStore } from '../store/core.store';

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    NgIf,
    NgFor,
    RouterModule,
    BreadcrumbsComponent,
  ],
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
  @ViewChild('drawer') drawer!: MatSidenav;
  coreStore = inject(CoreStore);
  constructor(private router: Router) {
    effect(() => {
      this.navigationLinks.set(
        this.generateNavigationLinks(this.coreStore.securityRoles())
      );
    });
  }

  readonly opened = signal(true);
  readonly sidenavMode = 'side';
  navigationLinks = signal(
    [] as { url: string; icon: string; label: string }[]
  );

  // Only show skeleton while user (auth) not yet resolved
  readonly isLoading = computed(() => !this.coreStore.user());

  readonly userInitials = computed(() => {
    const name = this.coreStore.user()?.name ?? '';
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase();
  });

  readonly skeletonItems = [1, 2, 3, 4, 5];

  toggleSidenav() {
    this.opened.set(!this.opened());
  }

  close() {
    this.opened.set(false);
  }

  generateNavigationLinks(securityRoles: string[]) {
    return SidenavLinks.filter((link) => {
      return link.securityRoles.some((role) => securityRoles.includes(role));
    });
  }
}
